import { render, staticRenderFns } from "./PrePurchasedAssignCard.vue?vue&type=template&id=62ef33f0&"
import script from "./PrePurchasedAssignCard.vue?vue&type=script&lang=js&"
export * from "./PrePurchasedAssignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports